import { apiFetch } from '../../apiFetch'

export const getAdminNpcs = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  return await apiFetch({
    path: `/admin/npcs${query ? `?${query}` : ''}`
  })
}

export const getAdminNpc = async (id) => {
  return await apiFetch({
    path: `/admin/npcs/${id}`
  })
}

export const createAdminNpc = async (data) => {
  return await apiFetch({
    path: '/admin/npcs',
    method: 'POST',
    payload: data
  })
}

export const updateAdminNpc = async (id, data) => {
  return await apiFetch({
    path: `/admin/npcs/${id}`,
    method: 'PUT',
    payload: data
  })
}

export const deleteAdminNpc = async (id) => {
  return await apiFetch({
    path: `/admin/npcs/${id}`,
    method: 'DELETE'
  })
}
